import { AutofillEntitiesTable } from "@/components/partial";

function AdminDocumentAutofillEntities() {
  return <AutofillEntitiesTable />;
}

export default AdminDocumentAutofillEntities;
